import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getWallet } from '../api/client';
import './Navbar.css';

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuth();
  const isActive = (path) => location.pathname === path;
  const [treats, setTreats] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  React.useEffect(() => {
    if (isAuthenticated) {
      getWallet().then(r => setTreats(r.data.treats)).catch(() => {});
      const interval = setInterval(() => {
        getWallet().then(r => setTreats(r.data.treats)).catch(() => {});
      }, 30000);
      return () => clearInterval(interval);
    }
  }, [isAuthenticated]);

  // Close menu on navigation
  React.useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-inner container">
        <Link to="/" className="navbar-logo" aria-label="Petlings home">
          <img
            src="/branding/petlings-wordmark-300.png"
            srcSet="/branding/petlings-wordmark-300.png 1x, /branding/petlings-wordmark-600.png 2x, /branding/petlings-wordmark-1200.png 4x"
            alt="Petlings"
            className="navbar-logo-img"
            draggable="false"
          />
        </Link>

        {/* Hamburger button */}
        <button className={`navbar-hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          <span /><span /><span />
        </button>

        <div className={`navbar-menu ${menuOpen ? 'navbar-menu-open' : ''}`}>
          <div className="navbar-links">
            <Link to="/" className={isActive('/') ? 'active' : ''}>Home</Link>
            <Link to="/pets" className={location.pathname.startsWith('/pets') ? 'active' : ''}>My Pets</Link>
            <Link to="/catalog" className={isActive('/catalog') ? 'active' : ''}>Catalog</Link>
            <Link to="/shop" className={isActive('/shop') ? 'active' : ''}>Shop</Link>
            <Link to="/about" className={isActive('/about') ? 'active' : ''}>About</Link>
          </div>

          <div className="navbar-actions">
            {isAuthenticated ? (
              <div className="navbar-user">
                <Link to="/shop" className="navbar-treats" title="Treats balance">
                  🦴 {treats ?? '...'}
                </Link>
                <Link to="/profile" className="navbar-username">
                  {user?.username || user?.email?.split('@')[0] || 'Account'}
                </Link>
                <button className="navbar-logout-btn" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            ) : (
              <Link to="/login" className="btn btn-primary btn-sm">Sign In</Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
